import type { ReactNode } from 'react';

export const symbol_crop_21_9: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-280q-24 0-42-18t-18-42v-280q0-24 18-42t42-18h680q24 0 42 18t18 42v280q0 24-18 42t-42 18H140Zm0-60h680v-280H140v280Zm0 0v-280 280Z"
		/>
	</svg>
);
